import { handleGqlResponseBody } from "@/utils/apollo.util";
import {GET_PRODUCT_BRAND_PAGINATED_QUERY} from '@/graphql/product/brand.query';
import {GET_PRODUCT_CATEGORY_PAGINATED_QUERY} from '@/graphql/product/category.query';
import {GET_BRANCH_PAGINATED_QUERY} from '@/graphql/branch/branch.query';
import {GET_COUPON_PAGINATED_QUERY} from '@/graphql/coupon/coupon.query';
import {GET_PRODUCT_SUBCATEGORY_PAGINATED_QUERY} from '@/graphql/product/subcategory.query';

const storeSettings = {
  actions: {
    async getProductBrandPaginatedQuery({ commit }, { skip, take, orderBy }) {
      return await handleGqlResponseBody(({ query }) => {
        return query({
          query: GET_PRODUCT_BRAND_PAGINATED_QUERY,
          variables: {
            skip,
            take,
            orderBy
          },
          fetchPolicy: 'no-cache',
        });
      });
    },
    async getProductCategoryPaginatedQuery({ commit }, { skip, take, orderBy }) {
      return await handleGqlResponseBody(({ query }) => {
        return query({
          query: GET_PRODUCT_CATEGORY_PAGINATED_QUERY,
          variables: {
            skip,
            take,
            orderBy
          },
          fetchPolicy: 'no-cache',
        });
      });
    },
    async getProductSubcategoryPaginatedQuery({ commit }, { skip, take, orderBy }) {
      return await handleGqlResponseBody(({ query }) => {
        return query({
          query: GET_PRODUCT_SUBCATEGORY_PAGINATED_QUERY,
          variables: {
            skip,
            take,
            orderBy
          },
          fetchPolicy: 'no-cache',
        });
      });
    },
    async getBranchPaginatedQuery({ commit }, { skip, take, orderBy }) {
      return await handleGqlResponseBody(({ query }) => {
        return query({
          query: GET_BRANCH_PAGINATED_QUERY,
          variables: {
            skip,
            take,
            orderBy
          },
          fetchPolicy: 'no-cache',
        });
      });
    },
    async getCouponPaginatedQuery({ commit }, { skip, take, orderBy }) {
      return await handleGqlResponseBody(({ query }) => {
        return query({
          query: GET_COUPON_PAGINATED_QUERY,
          variables: {
            skip,
            take,
            orderBy
          },
          fetchPolicy: 'no-cache',
        });
      });
    },
  },
};

export default storeSettings;
